/**
 * @architecture-header 1
 * @layer module
 * @domain help
 * @responsibility Client-side, in-memory search and contextual ranking over the static help
 *   article set -- no backend query, since the whole content set ships in the bundle (CONTRACT
 *   APPROVED R1).
 * @state-owner none -- pure function over caller-supplied data
 * @allowed-imports shared workspace section type; same-module content types
 * @forbidden network; database access; React
 * @public-api modules/help
 * @side-effects none
 * @tests search.test.ts
 */

import type { WorkspaceSection } from '../../shared/lib/model';
import type { HelpArticle } from './content/articles';

export function searchArticles(
  articles: readonly HelpArticle[],
  query: string,
  activeSection: WorkspaceSection,
): readonly HelpArticle[] {
  const trimmed = query.trim().toLowerCase();
  if (trimmed === '') {
    const inSection = articles.filter((article) => article.sections.includes(activeSection));
    const outOfSection = articles.filter((article) => !article.sections.includes(activeSection));
    return [...inSection, ...outOfSection];
  }
  return articles.filter(
    (article) =>
      article.title.toLowerCase().includes(trimmed) ||
      article.body.toLowerCase().includes(trimmed) ||
      article.keywords.some((keyword) => keyword.toLowerCase().includes(trimmed)),
  );
}
